import { Box, Typography } from '@mui/material';
import React from 'react';

interface JobDescriptionContentProps {
  jobInfo: any;
}

const JobDescriptionContent: React.FC<JobDescriptionContentProps> = ({
  jobInfo,
}) => {
  const getPositionType = () => {
    if (jobInfo?.positionType === 'Contract to Hire') return 'C2H';
    if (jobInfo?.positionType === 'Direct Hire') return 'DH';
    if (jobInfo?.positionType === 'Contract') return 'Contract';
    return '-';
  };

  const getWorkStatus = () => {
    return (
      jobInfo?.jobWorkStatus
        ?.map((ws: any) => ws.workStatus?.name)
        .filter(Boolean)
        .join(', ') || '-'
    );
  };

  const getExperience = () => {
    const from = Number(jobInfo?.expFrom);
    const to = Number(jobInfo?.expTo);
    if (from > 0 && to > 0) {
      return `${from} - ${to}`;
    } else if (from > 0) {
      return `${from}`;
    } else if (to > 0) {
      return `${to}`;
    } else {
      return '-';
    }
  };

  const getLocation = () => {
    const city = jobInfo?.city?.trim();
    const state = jobInfo?.state?.trim();
    if (city && state) return `${String(city)}, ${String(state)}`;
    return String(city || state || '-');
  };

  const renderDescription = () => {
    const jobDescription = jobInfo?.jobDescription;
    const hasHtmlTags =
      jobDescription && /<[a-z][\s\S]*>/i.test(jobDescription);

    if (hasHtmlTags) {
      return (
        <Typography
          component="div"
          className="description job-description-html"
          dangerouslySetInnerHTML={{
            __html: jobDescription || '',
          }}
        />
      );
    }

    return (
      <Typography component="div" className="description job-description-text">
        {jobDescription?.replace(/\n/g, '\n') || ''}
      </Typography>
    );
  };

  return (
    <>
      {renderDescription()}

      <Box className="info-cards">
        <Box className="info-card pay-rate">
          <span className="value">
            {(() => {
              const from = Number(jobInfo?.payRangeFrom);
              const to = Number(jobInfo?.payRangeTo);
              if (from > 0 && to > 0) {
                return `$${from} - $${to}`;
              } else if (from > 0) {
                return `$${from}`;
              } else if (to > 0) {
                return `$${to}`;
              } else {
                return '-';
              }
            })()}
          </span>
          <span className="label">Pay Rate</span>
        </Box>
        <Box className="info-card start-date">
          <span className="value">
            {jobInfo?.startDate
              ? new Date(jobInfo.startDate).toLocaleDateString()
              : '-'}
          </span>
          <span className="label">Project Start Date</span>
        </Box>
        <Box className="info-card pos-type">
          <span className="value">{getPositionType()}</span>
          <span className="label">Position Type</span>
        </Box>
      </Box>

      <Box className="details-list">
        {[
          {
            label: 'Education',
            value: jobInfo?.education || '-',
          },
          {
            label: 'Interview Type',
            value: jobInfo?.interviewType || '-',
          },
          { label: 'Experience', value: getExperience() },
          { label: 'Duration', value: jobInfo?.duration || '-' },
          { label: 'Location', value: getLocation() },
          {
            label: 'Work Status',
            value: getWorkStatus(),
          },
          {
            label: 'Certifications',
            value: jobInfo?.certificates || '-',
          },
          {
            label: 'Sales Person',
            value: jobInfo?.user
              ? [jobInfo.user.firstName, jobInfo.user.lastName]
                  .filter(Boolean)
                  .join(' ') || '-'
              : '-',
          },
          {
            label: 'Expected Resume Score',
            value: jobInfo?.expectedResumeScore || '-',
          },
        ].map((item) => (
          <Box key={item.label} className="detail-item">
            <span className="label">{item.label}</span>
            <span className="value">{item.value}</span>
          </Box>
        ))}
      </Box>

      {jobInfo?.jobSkills && jobInfo.jobSkills.length > 0 && (
        <Typography component="div" className="exp-tables">
          <table>
            <thead>
              <tr>
                <th className="w-50">Skills</th>
                <th className="w-25"># Yrs Required</th>
                <th className="w-23">Preferred</th>
              </tr>
            </thead>
            <tbody>
              {jobInfo.jobSkills.map((item: any, index: number) => (
                <tr key={index}>
                  <td className="w-50">{item?.skill?.name}</td>
                  <td className="w-25">{item?.required}</td>
                  <td className="w-23">{item?.preffered}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Typography>
      )}
    </>
  );
};

export default JobDescriptionContent;
